import { useMarketPerformanceTimeseries } from './useMarketPerformanceTimeseries';
import type { BenchmarkType } from './useUpdatePortfolioBenchmark';

type Args = {
  benchmark: string;
  benchmarkType: BenchmarkType;
  periodStart: number;
  periodEnd: number;
};

export const useBenchmarkTimeseries = ({
  benchmark,
  benchmarkType,
  periodStart,
  periodEnd,
}: Args) => {
  const marketTimeseries = useMarketPerformanceTimeseries({
    market: benchmark,
    periodStart,
    periodEnd,
    enabled: benchmarkType === 'MARKET',
  });

  // TODO: Implement ETF timeseries fetching logic here

  if (benchmarkType === 'MARKET') {
    return {
      status: marketTimeseries.status,
      data: marketTimeseries.data,
    };
  }

  return {
    status: 'error',
    data: {},
  };
};
